import * as jwt from 'jsonwebtoken'
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const credentials = {
    "type": "service_account",
    "project_id": "barttopivo-395707",
    "private_key_id": "1107e3fca6a6e73d5e57eff30c682a5f26efd415",
    "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEuwIBADANBgkqhkiG9w0BAQEFAASCBKUwggShAgEAAoIBAQCUYK7lsrHEK5Mm\nth9osWugO++zlabCi3wxE/qUR2N6n0qb79SpRXDoXM9qW2aWKqwNhr6PTLVE5g/R\namkkK7AZMhBEnRyFe5f8GMLdS8OMrzrlaANEZcT1hKyC7gUbEfR3cfIswrSLhJqM\n7NAbdMbgkJKUQqtUfH44HdXYPK0RbcgfPvGgLn9YLn76TWFsTmYClAzEJXlZULvl\nf2KrTAyg89u/zA42I9gDoyUdSZvw7Du8eBplp2o29Z4fQ/Oeki/uwk+oxkYY3qZF\nOiks/xfuPTC9vGT3r+IASHATrvlseJ1X6U7B0BYYmHHaeR77x89VkXzCnEdXAGHh\nznSVCltpAgMBAAECgf91IPZaPUJNooCLmMgHkDRe9UeS7a1ZtBZ1WFt5FakXR7MD\n5OSnq0J84IwY5gmbMg/PaZoz6LAAJOd1MGbxbPXe//xa/hywyE8W4BFlET7k2yag\nz8N3eA6GgDDU5ppi6GyyCxhaStYAU8ZHJ373znSfWUGr/m0qvuD2scZCBaz4icyr\n8a8cjX7IVBbUsCP7M0e2e6tEUhQt3knIamqUxDYu6mfzval0l7aaZtlRifwK0ctQ\npkjs9WsOB0vvSFsLSBu9LAavtUXlIAitRi89SKQhJZnZlsBPKqc9E3zsGGKOwGjv\n0SHt35HMMfs6F100x8ohvr+Nj4PnL/K6VzKo/hECgYEAwxm5ni0Lbqy1eyhIaayH\n+JfkkqrjBObWEQCmrvqMy7OrLsjG3FwruLZT6qaaQYjnYHy5XSfd+K2d/zybHrLj\nA2wPLpjLDjiN8ZA2jE0IoCbi9rcthHK2MNBM/fhcrZSdLNcymYoWPRCjHAQroOiw\nhLP3+WKzyoGuaE/st4wbYE8CgYEAwrFi/2cFdqEix3Par1WSzxF1m3xqz701CsIq\nsFeyHqc52VAAXrO7uFVY6coXjQCVHeovmKxWdd56zVINRH+VHlNiZfBkEHKZdihN\nvkJNEtgOLj9eACZOl0V9fCF/273008XixDmReaqgmIfq4JWe7mFTbqC3ZpOFr6qa\n03GIIscCgYBzbOPRPgsWdl2EOIfm5SkonQyg7TMUclFRi9YRjbAA0BJFwolMU8eW\nJ2CsYda/UPS6s++iunRrrKPeHogTeHgwTR0KT2FKz5DCyrRK+0RQI9GBb0whoRBC\n/umeE/MYyuTWY5bPGdAgXphxedIqB6BvUl4yEAAYnfKGSkrdKKoFpwKBgA7OXrD9\nrLSw3Gw+q0raPyfwM/l3JMhXo0kGKyjuAmXCYevc4apSENyb4P8ml1Ppz21O+f+q\nW4jrOnuS2d9ztGtx+/G0rmdxz6nktsTZVfMw6yMpPoTUZPWsGzbtdUPI1m2khvJV\nTnLqPvxamcoqlsOaMzYektQCNBB/8PZTk/7RAoGBAIgOUNvDS/dikcH8HNLGdps+\nEoapI7T1SD9EBpSC2mDs0yHVz5tYQb+KwQnNTppqxY4VCdUmxo/GOCvTUp28fVJN\nkxk1N5xMLCf2LJL+g4xYBnkTt2KFKI60udQaRkhOq+E3IjEM4gUkZqBbdWVFFupP\nckwufUbklSyFcKMQIWYt\n-----END PRIVATE KEY-----\n",
    "client_email": "client-web-wallet@barttopivo-395707.iam.gserviceaccount.com",
    "client_id": "108781569583335822546",
    "auth_uri": "https://accounts.google.com/o/oauth2/auth",
    "token_uri": "https://oauth2.googleapis.com/token",
    "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
    "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/client-web-wallet%40barttopivo-395707.iam.gserviceaccount.com",
    "universe_domain": "googleapis.com"
}
const issuerId = '3388000000022260055';
const classId = `${issuerId}.topivocode`;

export const useGoogleWallet = (reference: string): string | undefined => {
    const {t, i18n} = useTranslation('googleWallet')
    const [googleWalletUrl, setGoogleWalletUrl] = useState<string | undefined>(undefined)

    useEffect(() => {
        if(reference) {
            setGoogleWalletUrl(createPassObject(reference, i18n.language, t('header')))
        }
    }, [reference, i18n.language, t])

    return googleWalletUrl
}

function createPassObject(reference: string, language: string, header: string) {
    const objectId = `${issuerId}.${reference}`;

    const genericObject = {
        'id': `${objectId}`,
        'classId': classId,
        'genericType': 'GENERIC_TYPE_UNSPECIFIED',
        'hexBackgroundColor': '#70A6DA',
        'logo': {
            'sourceUri': {
                'uri': 'https://autres1.s3.eu-west-3.amazonaws.com/logo_small.png'
            }
        },
        'cardTitle': {
            'defaultValue': {
                'language': language,
                'value': 'Bart topivo'
            }
        },
        'header': {
            'defaultValue': {
                'language': language,
                'value': header
            }
        },
        'barcode': {
            'type': 'QR_CODE',
            'value': `${reference}`,
            'alternateText': `${reference}`
        }
    };

// TODO: Create the signed JWT and link
    // TODO: Create the signed JWT and link
    const claims = {
        iss: credentials.client_email,
        aud: 'google',
        origins: [],
        typ: 'savetowallet',
        payload: {
            genericObjects: [
                genericObject
            ]
        }
    };

    const token = jwt.sign(claims, credentials.private_key, { algorithm: 'RS256' });
    return `https://pay.google.com/gp/v/save/${token}`;
}
